export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Calcolo del risparmio in Walutomat',
    rangeFrom: 'Voglio',
    forBuy: 'per',
    forSell: 'a',
    directionBuy: 'Acquistando',
    directionSell: 'Vendendo',
    payText: 'pagherà',
    sellText: 'riceverà',
    buySelect: 'acquistare',
    sellSelect: 'vendere',
    rateText: 'Tasso di cambio',
    amountText: 'Importo',
    includes: 'Include',
    commission: '{{commission}}% commissione',
    howItWorks: '',
    banksComapreOpen: 'Confronta con altri',
    banksComapreClose: "Chiudi l'elenco",
    savingsMonthly: 'Risparmiate anche una sola volta con Walutomat',
    savingsYearly: "sostituendo tutto l'anno, ogni mese.'",
    conjunction: 'e',
    serverError: 'Errore di comunicazione del server',
    unsupportedPair: 'Al momento non offriamo tassi per la coppia di valute selezionata.',
    infoError: {
      exchange: 'Su Walutomat.pl è possibile scambiare direttamente',
      transactionFee:
        "e indietro. Tale transazione in banca è associata a una commissione elevata, che di solito raggiunge anche il 5-10% dell'importo del cambio.",
    },
    spinnerError: {
      generic: 'Si è verificato un problema nel download dei dati',
      toManyRequests:
        'Il calcolatore è attualmente utilizzato da molti utenti. Riprova più tardi o contatta il Servizio clienti. <a href="https://www.walutomat.com/it/contatto/">https://www.walutomat.com/it/contatto/</a>',
    },
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title:
      'Controlla i tassi di cambio e{{nbsp}}converti la valuta in{{nbsp}}Walutomat – in modo rapido e{{nbsp}}vantaggioso.',
    actualRate: 'Tasso di cambio attuale',
    buySelect: 'Compro',
    sellSelect: 'Vendo',
    buttonText: 'Converti',
    exchangeAmountSellLabel: 'Riceverai',
    exchangeAmountBuyLabel: 'Deposito',
    commission: 'Commissione promozionale ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Il campo non può essere vuoto',
    requiredField: 'Il campo è obbligatorio',
    passwordToShort: 'La password deve essere di 8 caratteri',
    emailNotValid: 'Il campo deve contenere un indirizzo e-mail valido',
    emailReserved: "L'indirizzo e-mail è già occupato",
    rateEmpty: 'Tutti i campi devono essere compilati',
    serverUnknownError: 'Errore di comunicazione del server',
    invalidCharacters: 'Il campo contiene caratteri non validi',
    phoneNotValid: 'Il numero di telefono non è corretto',
    checkBoxBelow: 'Selezionare la casella sottostante per inviare un messaggio',
  },
  password: {
    show: 'mostrare',
    hide: 'nascondere',
  },
  howItWorks: {
    showButton: 'Mostra di più',
    hideButton: 'Mostra meno',
  },
}
